import { type CSSProperties, type PropsWithChildren, type ReactElement, useState } from "react"

import { Button } from "~/shared/ui/kit/components/Button"
import { Message } from "~/shared/ui/kit/components/Message"
import { inv } from "~/shared/lib/utils"
import { Href } from "~/shared/ui/components/Href"
import { IconButton } from "~/shared/ui/kit/components/IconButton"
import type { ContactsType } from "~/shared/ui/components/Contacts"
import { Contacts } from "~/shared/ui/components/Contacts"
import { MaterialIcon } from "~/shared/ui"

export function LinkWithContact(props: PropsWithChildren<{
	backgroundColor?: string,
	textColor?: string,
	href: string,
	contact?: ContactsType,
	icon?: string | ReactElement,
	outlinedIcon?: boolean
}>) {

	const [showContacts, setShowContacts] = useState(false)

	let icon = props.icon

	if (icon && typeof icon === "string") icon = <MaterialIcon name={icon} outlined={props.outlinedIcon} />

	return <div>
		<Message style={{ background: props.backgroundColor }} className="flex flex-col gap-[1rem]">
			<div className="flex items-center" style={{ color: props.textColor }}>
				{icon}
				<Button colorStyle="dark" className="button-without-focus"
						style={{
							justifyContent: "flex-start",
							flex: "1 0 auto",
							textDecoration: "underline",
							color: props.textColor
						}}
						transparent borderless
						elementType={Href} href={props.href}>{props.children}</Button>

				{props.contact && <>
					<div style={{
						height: "2.5rem",
						width: "2px",
						paddingLeft: "0.5rem",
						borderLeft: "1px solid #00000014"
					}}></div>
					<IconButton transparent borderless colorStyle="dark"
								style={{
									color: props.textColor,
									width: "2.5rem",
									height: "2.5rem",
									fontSize: "1.5rem",
									borderRadius: "0"
								}}
								icon="contact_support"
								onClick={() => setShowContacts(inv)} />
				</>}
			</div>
			{showContacts && <div><Contacts {...props.contact} style={{ '--contact-color': props.textColor } as CSSProperties} /></div>}
		</Message>
	</div>
}